(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FranchiseTaxInfoManage',
	};

	// SET-88 AC 4. THE TAX ID FORMAT, CHECKED WHEN THE FIELD LOSES FOCUS.
	//
	// THESE ARE THE SERVER'S OWN TWO REGEXES, CHARACTER FOR CHARACTER.
	// ValidationComponent::_taxId() accepts an EIN as ##-####### or an SSN as ###-##-####, and
	// accepts either shape in either field. Copied rather than reasoned about, because a client
	// check stricter than the server rejects values the server would take, and one looser than
	// the server is not a check at all.
	var TAX_ID_FORMATS = [
		/^\d{2}-\d{7}$/,
		/^\d{3}-\d{2}-\d{4}$/,
	];

	var TAX_ID_FORMAT_MESSAGE = 'Format must be 12-3456789 or 123-45-6789';

	// The two fields, each with the id of the slot its message goes into.
	var TAX_ID_FIELDS = [
		{
			input: '#franchisetaxinfomanage-franchise_tax_info-ssn',
			slot : '#ssn_format_error',
		},
		{
			input: '#franchisetaxinfomanage-franchise_tax_info-employer_id',
			slot : '#employer_id_format_error',
		},
	];

	/**
	 * Shows or clears the format message for one Tax ID field.
	 *
	 * EMPTY IS NOT AN ERROR HERE. Neither field carries `required` on its own - the form's
	 * validate() works out from the classification which of the two is needed and reports that
	 * itself, with its own copy - so a blank field is a matter for submit, not for blur. A field
	 * the classification has disabled is skipped for the same reason: it does not post.
	 */
	function checkTaxIdFormat($input, $slot)
	{
		var value = $.trim($input.val()),
		    valid = false,
		    i;

		if ($input.prop('disabled') === true || value === '') {
			$slot.addClass('hidden').find('p').text('');
			$input.parent().removeClass('has-error');

			return;
		}

		for (i = 0; i < TAX_ID_FORMATS.length; i++) {
			if (TAX_ID_FORMATS[i].test(value)) {
				valid = true;
				break;
			}
		}

		if (valid) {
			$slot.addClass('hidden').find('p').text('');
			$input.parent().removeClass('has-error');

			return;
		}

		$slot.find('p').text(TAX_ID_FORMAT_MESSAGE);
		$slot.removeClass('hidden');

		// the class form.js's own markErrorFields() uses, so a blur-time error and a
		// server-reported one look the same rather than inventing a second error language
		$input.parent().addClass('has-error');
	}

	/**
	 * Arms the blur check, and ONLY where the view has provided somewhere to put the message.
	 *
	 * This file is shared: SET-104 moved it to the unprefixed path, so production's Add W9
	 * screen and the My Settings panel run the same js. Production's view renders no slots, so
	 * the check does not arm there and that screen keeps exactly the behaviour it has today -
	 * which is the point. Highlighting a field pink on blur with no message beside it would be
	 * worse than the nothing production does now.
	 */
	function bindTaxIdFormatCheck()
	{
		$.each(TAX_ID_FIELDS, function eachField(index, field) {
			var $input = $(field.input),
			    $slot  = $(field.slot);

			if (!$input.length || !$slot.length) {
				return;
			}

			$input.off('blur.taxIdFormat').on('blur.taxIdFormat', function blurred() {
				checkTaxIdFormat($input, $slot);
			});

			// a value already on screen is not checked - the advisor has not touched it yet, and
			// an error against a prefilled field reads as their mistake
		});
	}

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var was_previous_ftc_individual = null;

		// trigger change event on tax classification, since they are now pre-populated
		setTimeout(function triggered() {
			$('#franchisetaxinfomanage-franchise_tax_info-franchise_tax_classification_id').trigger('change');

			// SET-88. THIS TRIGGER IS WHY THE PANEL USED TO OPEN DIRTY, and the 100ms is the whole
			// of it. The handler above writes Legal Entity Name and the Exempt Payee Code and
			// toggles `disabled` on SSN and EIN - but the settings modal takes its entry snapshot
			// at my-settings:rendered, 100ms earlier. So the panel announced "You have unsaved
			// changes" and armed the leave guard before the advisor had touched anything.
			//
			// TWO SEPARATE WAYS IT READ AS AN EDIT, which is why this is fixed here rather than at
			// either write: the values differ, AND _snapshot() skips disabled controls while
			// _recompute() counts a control that has gone away since entry as a change.
			//
			// ONLY THIS TRIGGER, NEVER THE HANDLER ITSELF. When the ADVISOR changes the
			// classification, the same handler rewriting the name IS an edit and must stay dirty -
			// so the re-snapshot sits here, in load(), not in the change handler.
			//
			// GUARDED, because this form also renders on its own legacy page, where the settings
			// modal is not loaded at all. resetEntry() is SET-18's, built for Specialties, which
			// draws its inputs from stored values after render for the same reason.
			if (Adzuki.MySettings && Adzuki.MySettings.Save
				&& typeof Adzuki.MySettings.Save.resetEntry === 'function') {
				Adzuki.MySettings.Save.resetEntry();
			}
		}, 100);

		// SET-89. THE STRINGS MATCHED BELOW ARE DATABASE ROWS, NOT CONSTANTS.
		//
		// Every comparison in this handler is against the option's VISIBLE LABEL, which is
		// `franchise_tax_classifications.classification`. Renaming a row in that table therefore
		// changes which fields this form enables, with no code change, no error and nothing
		// logged. Read this before editing a classification name.
		//
		// The coupling was reviewed and kept deliberately (SET-89): keying the rules off ids or
		// off server-supplied metadata would mean re-deriving, during a migration, which of SSN,
		// EIN, the EIN upload and the exempt payee code an advisor may fill in on a tax form -
		// with no reference implementation left to compare against. So the strings below are
		// character for character what production has always matched, and must stay that way.
		//
		// The 11 rows as they stand, and what each one does (verified against excoloDev, 9 Sep
		// 2026 - id 1 is active = 0 and reachable only because load() passes $active_only = false
		// when the stored classification IS id 1, so an existing W9 keeps it):
		//
		//   label                                             SSN  EIN+file  exempt      name <-
		//   Individual/Sole Proprietor or Single-Member LLC    on   on        editable    owner
		//   Sole Proprietorship                                on   on        editable    owner
		//   Single-Member LLC                                  on   on        editable    owner
		//   C Corporation                                      off  on        readonly 5  business
		//   S Corporation                                      off  on        readonly 5  business
		//   Partnership                                        off  on        editable    business
		//   Trust/Estate                                       off  on        editable    business
		//   LLC - Corporation                                  off  on        readonly 5  business
		//   LLC - S Corporation                                off  on        readonly 5  business
		//   LLC - Partnership                                  off  on        editable    business
		//   Other                                              on   on        editable    business
		//
		// TWO THINGS THAT LOOK LIKE BUGS AND ARE THE SPECIFIED BEHAVIOUR:
		//
		// 1. THE EIN FIELDS ARE ENABLED FOR ALL ELEVEN. Every current label is either in the EIN
		//    array or contains "LLC", so the `$ein.prop('disabled', true)` branch below is dead
		//    against today's table. It is not removed: it comes alive the moment a row is added
		//    that satisfies neither test - "Estate" alone would do it - and deleting it now would
		//    silently enable the EIN for that new row. This is the clearest instance of the
		//    coupling above.
		//
		// 2. SSN AND EIN ARE BOTH ENABLED for the three individual/sole-proprietor labels and for
		//    "Other". That is what #ssn_ein_note is for ("enter either ... but NOT both"), and
		//    what validate()'s "cannot be submitted at the same time" error enforces on the
		//    server. Note that "Other" enables both and does NOT show the note, so that pairing
		//    is caught only at save.
		//
		// do all kinds of stuff based on federal tax classification value
		$('#franchisetaxinfomanage-franchise_tax_info-franchise_tax_classification_id').on('change', function click(e)
		{
			var tax_class    = $(this).find('option:selected').text(),
				$ftc_other   = $("#classification_other"),
				$exempt_code = $("#franchisetaxinfomanage-franchise_tax_info-exempt_payee_code"),
				$ssn         = $("#franchisetaxinfomanage-franchise_tax_info-ssn"),
				$ein         = $("#franchisetaxinfomanage-franchise_tax_info-employer_id"),
				$ein_file    = $("#franchisetaxinfomanage-franchise_tax_info-ein_backup_file"),
				$name        = $("#franchisetaxinfomanage-franchise_tax_info-legal_name");

			// show "other" textbox for custom input
			if (tax_class === "Other") {
				$ftc_other.removeClass('hidden').find('input').prop('disabled', false);
			} else {
				$ftc_other.addClass('hidden').find('input').prop('disabled', true);
			}

			// pre-populate exempt payee code for:
			// C Corporation, S Corporation, LLC - Corporation, LLC - S Corporation
			if (tax_class.indexOf('Corporation') === -1) {
				$exempt_code.prop('readonly', false).val('');
			} else {
				$exempt_code.prop('readonly', true).val('5');
			}

			// enable ssn field for these classifications
			if (['Individual/Sole Proprietor or Single-Member LLC', 'Sole Proprietorship', 'Single-Member LLC', 'Other'].indexOf(tax_class) === -1) {
				$ssn.prop('disabled', true);
			} else {
				$ssn.prop('disabled', false);
			}

			// enable ein field for these classifications
			if (['Sole Proprietorship', 'Partnership', 'Trust/Estate', 'C Corporation', 'S Corporation', 'Other'].indexOf(tax_class) === -1 && tax_class.indexOf("LLC") === -1) {
				$ein.prop('disabled', true);
				$ein_file.prop('disabled', true);
			} else {
				$ein.prop('disabled', false);
				$ein_file.prop('disabled', false);
			}

			// for this specific FTC, enable both ssn and ein and allow only one to be used
			// so basically, just take the data-required off both of them and display a notice
			if (['Individual/Sole Proprietor or Single-Member LLC', 'Sole Proprietorship', 'Single-Member LLC'].indexOf(tax_class) === -1) {
				// not individual/sp
				// also, for all FTC's that are not the above, pre-fill name with business_name
				$name.val($('#business_name').html());

				$('#ssn_ein_note').addClass('hidden');

				if (was_previous_ftc_individual) {
					// alert people to the name changing shenanigans
					Adzuki.StatusMessage('Warning', 'Changing the Federal Tax Classificiation can automatically adjust the Name field.<br><br>Please make sure it is correct before submitting.');
					was_previous_ftc_individual = false;
				}
			} else {
				// is individual/sp
				// all other FTC's, pre-fill name with primary owner first/last
				if (!$name.val()) {
					$name.val($('#first_name').html() + ' ' + $('#last_name').html());
				}

				// alert people to the name changing shenanigans
				if (was_previous_ftc_individual !== null) {
					Adzuki.StatusMessage('Warning', 'Changing the Federal Tax Classificiation can automatically adjust the Name field.<br><br>Please make sure it is correct before submitting.');
				}

				$('#ssn_ein_note').removeClass('hidden');

				was_previous_ftc_individual = true;
			}
		});

		// monitor address changes
		$('.monitor-changes').on('keyup change', function click(e)
		{
			var $self   = $(this),
			    origVal = $self.data('original'),
			    newVal  = $self.val();

			if (origVal === newVal) {
				$('#franchisetaxinfomanage-franchise_tax_info-address_changed').val('0');
				$('#address_change_warning').addClass('hidden');
			} else {
				$('#franchisetaxinfomanage-franchise_tax_info-address_changed').val('1');
				$('#address_change_warning').removeClass('hidden');
			}
		});

		// strike out appropriate text if the notified by IRS checkbox is checked
		if ($('#franchisetaxinfomanage-franchise_tax_info-notified_by_irs').prop('checked') === true) {
			$('#irs_notified').addClass('strikethrough');
		}

		// add/remove strike out based on notified checkbox
		$('#franchisetaxinfomanage-franchise_tax_info-notified_by_irs').on('change', function click(e)
		{
			$('#irs_notified').toggleClass('strikethrough');
		});

		bindTaxIdFormatCheck();
	};
}(jQuery, window.Adzuki || {}));
